import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Select, SimpleGrid, Stack, Text } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { toggleValue } from "../../general/generalPreferenceForm";
import { getImplantPreferenceDefaults } from "../implantPreferenceForm";

const FAVORITE_SYSTEMS = [
  "Straumann Bone Level",
  "Nobel Active",
  "Anthogyr Axiom",
  "MIS C1",
  "Zimmer TSV",
];
const DEFAULT_SYSTEMS = [
  "Straumann — Bone Level",
  "Nobel Biocare — Active",
  "Anthogyr — Axiom",
  "MIS — C1",
  "Zimmer — TSV",
];
const PLATFORMS = ["NC · Ø 3,3 mm", "RC · Ø 4,1 mm"];

export const ImplantSystemPreferences = withForm({
  defaultValues: getImplantPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "favoriteSystems",
      "defaultSystem",
      "platform",
    ]);

    return (
      <SaveableCard
        title="Systèmes implantaires"
        description="Vos systèmes habituels remontent en tête de liste dans le flux"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Systèmes favoris</Text>
            <form.Field name="favoriteSystems">
              {field => (
                <Group>
                  {FAVORITE_SYSTEMS.map(system => (
                    <ButtonCheckbox
                      key={system}
                      id={system}
                      isActive={field.state.value.includes(system)}
                      onClick={() =>
                        field.handleChange(values =>
                          toggleValue(values, system)
                        )
                      }
                    >
                      {system}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Système par défaut</Text>
              <form.Field name="defaultSystem">
                {field => (
                  <Select
                    data={DEFAULT_SYSTEMS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Plateforme</Text>
              <form.Field name="platform">
                {field => (
                  <Select
                    data={PLATFORMS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
        </Stack>
      </SaveableCard>
    );
  },
});
